(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('CentroDocente', CentroDocente);

    CentroDocente.$inject = ['$resource'];

    function CentroDocente ($resource) {
        var resourceUrl =  'api/centro-docentes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'all': { 
            	method: 'GET',
            	url:'api/centro-docentes-all',
            	isArray: true
           	},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getByCurrentUser': {
                method: 'GET',
            	url:'api/centro-docentes-by-current-user',
            	isArray: true
            },
            'update': { method:'PUT' }
        });
    }
})();
